import { Box, Divider, Grid, Typography } from '@material-ui/core';
import { Button, IconButton, FileUpload, FileUploadModal, TextField, FileUploadArea } from '@roc/ui';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import { CloudDownload } from '@material-ui/icons';
import { useAppraisalReportFormStore } from '../../../hooks/useAppraisalReportFormStore';

export const AppraisalReportForm = observer(
  ({ document, handleClose }: { document: any; handleClose: () => void }) => {
    const {
      documentStore: { documentFormStore },
    } = useDocumentStore();
    const { appraisalReportFormStore } = useAppraisalReportFormStore();
    const [uploadPdf, setUploadPdf] = useState<FileUpload[]>([]);
    const [uploadXml, setUploadXml] = useState<FileUpload[]>([]);

    const onSave = async () => {
      if (uploadPdf[0] && uploadXml[0]) {
        appraisalReportFormStore.uploadFiles(document, uploadPdf[0], uploadXml[0]);
        if (handleClose) handleClose();
      } else {
        showErrorAlert('Appraisal Report PDF and Appraisal Report XML are required');
      }
    }

    const showErrorAlert = (message: string) => {
      appraisalReportFormStore.showErrorMessage(message);
    }

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          {appraisalReportFormStore.canDownloadFile && (
            <Box display="flex" justifyContent="flex-end">
              <IconButton
                type="submit"
                color="primary"
                testId="save"
                onClick={() => appraisalReportFormStore.downloadDocument()}
              >
                <CloudDownload />
              </IconButton>
            </Box>
          )}
        </Grid>
        <Grid xs={12}>
          <Typography style={{ display: 'inline-block', paddingLeft: '10px' }}>Upload Appraisal Report - PDF Format</Typography>
        </Grid>
        <Grid item xs={12}>
          <FileUploadArea
            items={uploadPdf}
            setItems={(items) => setUploadPdf(items)}
            multiple={false}
            fileType='pdf'
          />
        </Grid>
        <div></div>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <div><br></br></div>
        <Grid container direction="row" justifyContent="flex-start">
          <Typography style={{ display: 'inline-block', paddingLeft: '10px' }}>Upload Appraisal Report - XML Format</Typography>
        </Grid>
        <Grid item xs={12}>
          <FileUploadArea
            items={uploadXml}
            setItems={(items) => setUploadXml(items)}
            multiple={false}
            fileType='xml'
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            testId="save"
            fullWidth
            onClick={onSave}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    );
  }
);
